import { FileUploader } from "react-drag-drop-files";
import { colors } from "../colors";
import styled from "styled-components";

const fileTypes = ["JPG", "PNG", "JPEG"];

const DragDropWrapper = styled.div`
  width: 100%;
  max-width: 100%;

  & > label {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 1rem !important;
  }

  & > label > div {
    width: 100% !important;
    max-width: 100% !important;
  }

  @media (max-width: 768px) {
    & > label {
      padding: 0.75rem !important;
      font-size: 0.875rem !important;
    }
  }
`;

export type LogoFile = {
  name: string;
  type: MimeTypes;
  base64: string;
};

export type MimeTypes = "image/jpeg" | "image/png";

export type DragDropProps = {
  onLogoChange: (logo: LogoFile) => void;
  enforceSquare?: boolean;
  label?: string;
};

export const DragDrop = (props: DragDropProps) => {
  const { onLogoChange, enforceSquare = false, label = "Upload or drop your image here" } = props;

  const handleChange = (file: any) => {
    if (enforceSquare) {
      // Check if image is square (1:1 aspect ratio)
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.onload = () => {
          if (img.width !== img.height) {
            alert("Please upload a square image (1:1 aspect ratio)");
            return;
          }

          onLogoChange({
            name: file.name,
            type: file.type,
            base64: e.target?.result?.toString() || "",
          });
        };
        img.src = e.target?.result?.toString() || "";
      };

      reader.readAsDataURL(file);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          onLogoChange({
            name: file.name,
            type: file.type,
            base64: reader.result.toString(),
          });
        }
      };
      reader.onerror = (error) => {
        console.error("Error: ", error);
      };
    }
  };

  return (
    <DragDropWrapper>
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        multiple={false}
        label={label}
        hoverTitle=""
        maxSize={1}
        dropMessageStyle={{ backgroundColor: colors.gold + 10 }}
      />
    </DragDropWrapper>
  );
};
